export default {
  activeNetwork: null
};
